// extracted by mini-css-extract-plugin
export var pageWorksItems = "page-works-module--page-works__items--Vzi1f";